// Top Navigation
export const topNavBackground = "#1B5E20"; // deep hospital green
export const topNavText = "#FFFFFF"; // white text for contrast

// Sidebar
export const sideBarBackground = "#E8F5E9"; // very light green
export const sideBarText = "#1B5E20"; // deep green text

export const subMenuBackground = "#C8E6C9"; // light green
export const subMenuText = "#1B5E20"; // dark green
export const subMenuHoverText = "#2E7D32"; // hover green

export const subMenuSelectedBackground = "#A5D6A7"; // selected green
export const subMenuSelectedText = "#0D3B12"; // strong green

// Main Content Area
export const mainContentBackground = "#F1F8E9"; // soft hospital white-green
export const mainContentText = "#1B5E20"; // readable dark green

// Footer
export const footerBackground = "#E8F5E9"; // same as sidebar
export const footerText = "#1B5E20"; // consistent text color

// Table styles
export const theadBorder = "#81C784"; // soft green border
export const theadBackground = "#2E7D32"; // strong green header
export const theadText = "#FFFFFF"; // white header text

export const tbodyBorder = "#C8E6C9"; // subtle row border
export const tbodyBackground = "#FFFFFF"; // clean white rows
export const tbodyText = "#1B5E20"; // dark green text

// Tree / Section Titles
export const treeTitleBackground = "#DCEDC8"; // pale green highlight
